export function prepareCookies(url: string, cookiePrefix: string) {
  const urlObj = new URL(url)

  return {
    [cookiePrefix + 'token']: urlObj.searchParams.get('token'),
    [cookiePrefix + 'type']: urlObj.searchParams.get('type'),
    [cookiePrefix + 'migrationId']: urlObj.searchParams.get('migrationId')
  }
}
